import { render, staticRenderFns } from "./ContainerStepper.vue?vue&type=template&id=53fe8b8d&scoped=true&"
var script = {}
import style0 from "./ContainerStepper.vue?vue&type=style&index=0&id=53fe8b8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe8b8d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53fe8b8d')) {
      api.createRecord('53fe8b8d', component.options)
    } else {
      api.reload('53fe8b8d', component.options)
    }
    module.hot.accept("./ContainerStepper.vue?vue&type=template&id=53fe8b8d&scoped=true&", function () {
      api.rerender('53fe8b8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Checkout/components/steps/ContainerStepper.vue"
export default component.exports